import { useRef, useState, useCallback, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import axiosService from "../../utils/axios.service";
import { formatValue } from "react-currency-input-field";
import Delete from "./Delete";
import TransactionItem from "./items/TransactionItem";
import { notifications } from "../constant/Notify";
import { PrintTransactionItem } from "./PrintTransactionItem";
import _ from "lodash";
import { role } from "../../enums/role.enum";
import socketIOClient from "socket.io-client";
import { Spin } from "antd";

export function TransactionPopup(props) {
  const customerId = props?.customer?.id ? Number(props.customer.id) : null;

  const [showDelete, setShowDelete] = useState(false);
  const [dataTransaction, setDataTransaction] = useState({});
  const [selectDataStore, setSelectDataStore] = useState([]);
  const [dataOrderCustomerTransaction, setOrderCustomerTransaction] = useState([]);
  const [transactionItem, setTransactionItem] = useState(null);
  const [order, setOrder] = useState(null);
  const [depositMoney, setDepositMoney] = useState(props?.customer?.deposit_money ?? 0);
  const [showPrint, setShowPrint] = useState(true);
  const [bankingType, setBankingType] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [screen, setScreen] = useState(Number(localStorage.getItem("screen_qr")) || 3);

  const socketRef = useRef(null);
  const invoiceRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);

  const userAdmin = JSON.parse(localStorage.getItem("user_info")) || {};

  const requestDataStore = async () => {
    try {
      const response = await axiosService("api/stores/all", "GET");

      if (response.data.code === 200 && response.data.data) {
        const stores = response.data.data.map((item) => ({
          value: item.id,
          label: item.name_store,
          status: item.status,
        }));

        setSelectDataStore(stores);
      }
    } catch (error) {
      console.error("Lỗi lấy danh sách cửa hàng:", error);
    }
  };

  const requestDataTransactionCustomer = useCallback(
    async (orderId = null) => {
      if (!customerId) return;

      setLoading(true);
      try {
        const response = await axiosService(`api/transaction/customer/${customerId}/${orderId ?? null}`, "GET");

        if (response.data.code === 200) {
          if (props.setDataPayment) props.setDataPayment(response.data.data)
          setOrderCustomerTransaction(response.data.data.data);
        }
      } catch (error) {
        console.error("Lỗi lấy giao dịch khách hàng:", error);
      } finally {
        setLoading(false);
      }
    },
    [customerId],
  );

  const deleteTransaction = async () => {
    try {
      const response = await axiosService(`api/transaction/delete/${dataTransaction.id}`, "PUT", { customer_id: customerId });

      console.log(response.data)
      if (response.data.success === true) {
        requestDataTransactionCustomer();
        setShowDelete(false);
        notifications({ type: "success", mess: "Xóa giao dịch thành công" });

        if (props.isCustomerPage) props.setDataCustomer(response.data.data.deposit_money);
        
        setDepositMoney(response.data.data.deposit_money);
      } else {
        notifications({ type: "error", mess: response.data.message });
      }
    } catch (error) {
      console.error("Lỗi xóa giao dịch:", error);
      notifications({ type: "error", mess: "Không thể xóa giao dịch" });
    }
  };

  const handleDelete = (item) => {
    setShowDelete(true);
    setDataTransaction(item);
  };

  const printInvoiceT = (item, value) => {
    setTransactionItem(item);
    setOrder(value);
    printInvoice();
  };

  const handleOnBeforeGetContent = useCallback(() => {
    setShowPrint(false);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      resolve();
    });
  }, []);

  const handleAfterPrint = useCallback(() => {
    setShowPrint(true);
  }, []);

  const printInvoice = useReactToPrint({
    content: () => invoiceRef.current,
    onBeforeGetContent: handleOnBeforeGetContent,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const onChangeScreen = (event) => {
    const nextScreen = Number(event.value);

    localStorage.setItem("screen_qr", String(nextScreen));
    setScreen(nextScreen);
  };

  useEffect(() => {
    if (userAdmin.role === role.LT) setBankingType(1);
    if (userAdmin.role === role.SALE) setBankingType(2);
  }, [userAdmin]);

  useEffect(() => {
    requestDataStore();
    requestDataTransactionCustomer()
    const socket = socketIOClient(process.env.REACT_APP_API_SOCKET, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });

    socketRef.current = socket;

    return () => {
      socket.removeAllListeners();
      socket.disconnect();

      if (socketRef.current === socket) {
        socketRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const socket = socketRef.current;
    if (!socket || !customerId) return;
    const joinPaymentRoom = () => {socket.emit("payment:join", { customerId })};

    const handlePayment = (data) => {
      
      if (!data) return;

      switch (Number(data.status)) {
        case 1:
          setPaymentProcessing(true);
          break;
        case 2:
          setPaymentProcessing(false);
          break;
        case 3:
          requestDataTransactionCustomer()
          notifications({ type: "success", mess: "Thanh toán thành công" });
          setPaymentProcessing(false);
          break;
        default:
          break;
      }
    };

    socket.on("connect", joinPaymentRoom);
    socket.on("payment", handlePayment);
    if (socket.connected) joinPaymentRoom();

    return () => {
      socket.off("connect", joinPaymentRoom);
      socket.off("payment", handlePayment);
    };
  }, [customerId]);

  return (
    <Spin spinning={loading || paymentProcessing} size="large" tip={paymentProcessing ? "Đang kiểm tra thông tin chuyển khoản" : "Đang tải..."}>
      <div className="head-popup">
        <div className="title">
          Chi tiết:
          <span style={{ color: "#2196F3" }}>
            {props.customer?.full_name}
            {props.customer?.identifier === 1 ? (
              <span className="identifier-customer">
                <img src="/icons/verified.png" alt="Đã xác minh" />
              </span>
            ) : null}
          </span>
          <span style={{ color: "#5e6d8c" }}>
            - Tiền trong tài khoản: {formatValue({ value: String(depositMoney ?? 0), groupSeparator: ",", decimalSeparator: "." })}
          </span>
        </div>
      </div>

      <div className="body-popup">
        {!loading && dataOrderCustomerTransaction?.length > 0
          ? dataOrderCustomerTransaction.map((value) => (
              <TransactionItem
                key={value.id}
                order={value}
                customer={props.customer}
                selectDataStore={selectDataStore}
                screen={screen}
                userAdmin={userAdmin}
                bankingType={bankingType}
                socketRef={socketRef}
                onChangeScreen={onChangeScreen}
                printInvoiceT={printInvoiceT}
                handleDelete={handleDelete}
                setDepositMoney={setDepositMoney}
                getDataTransaction={props.getDataTransaction}
                setDataCustomer={props.setDataCustomer}
                isCustomerPage={props.isCustomerPage}
                notifications={notifications}
                requestDataTransactionCustomer={requestDataTransactionCustomer}
              />
            ))
          : null}
      </div>

      <Delete
        show={showDelete}
        dataTransaction={dataTransaction}
        deleteTransaction={deleteTransaction}
        close={() => setShowDelete(false)}
      />

      {transactionItem && props.customer && order ? (
        <div style={{ display: "none" }}>
          <PrintTransactionItem
            ref={invoiceRef}
            transactionItem={transactionItem}
            customer={props.customer}
            order={order}
          />
        </div>
      ) : null}
    </Spin>
  );
}
